import { render, staticRenderFns } from "./BaseCryptocomIcon.vue?vue&type=template&id=f2605bae&scoped=true"
import script from "./BaseCryptocomIcon.vue?vue&type=script&lang=js"
export * from "./BaseCryptocomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2605bae",
  null
  
)

export default component.exports